// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "NotFound" + "." + "d850a85d" + ".chunk.css";
};